import axios from 'axios';

// 获取存储的token
export const getToken = () => {
  return localStorage.getItem('adminToken');
};

// 设置axios请求头
export const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};

// 检查token是否有效
export const verifyToken = async () => {
  const token = getToken();
  
  if (!token) {
    return false;
  }

  try {
    setAuthToken(token);
    const response = await axios.get('/api/admin/verify');
    return response.data.success;
  } catch (error) {
    console.error('Token verification failed:', error);
    removeToken();
    return false;
  }
};

// 移除token
export const removeToken = () => {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminLoginTime');
  setAuthToken(null);
};

// 检查登录状态
export const isLoggedIn = () => {
  const token = getToken();
  const loginTime = localStorage.getItem('adminLoginTime');
  
  if (!token || !loginTime) {
    return false;
  }

  // 检查是否超过24小时
  const now = Date.now();
  const loginTimestamp = parseInt(loginTime);
  const hoursPassed = (now - loginTimestamp) / (1000 * 60 * 60);
  
  if (hoursPassed >= 24) {
    removeToken();
    return false;
  }

  return true;
};

// 登出
export const logout = async () => {
  const token = getToken();
  
  if (token) {
    try {
      setAuthToken(token);
      await axios.post('/api/admin/logout');
    } catch (error) {
      console.error('Logout error:', error);
    }
  }
  
  removeToken();
};
